import { Folder } from '@/api/generatedApi';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { getApiError } from '@/types/apiError';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { LIST_FOLDER_CONTENTS_QUERY_KEY } from './useFetchFolderContents';
import { GET_FOLDER_HIERARCHY_QUERY_KEY } from './useFolderHierarchy';
import { HAS_SUBFOLDER_DESCRIPTIONS_QUERY_KEY } from './useHasSubfolderDescriptions';
import { FOLDER_COLUMN_VISIBILITY_QUERY_KEY } from './useFolderColumnVisibility';

export const useCreateFolder = ({ parentFolder }: { parentFolder?: Folder }) => {
  const queryClient = useQueryClient();
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();
  const { mutate, isPending, error } = useMutation({
    mutationFn: ({ name, description }: { name: string; description?: string }) =>
      api.folders.createFolder(tenantId, { name, description, parentFolderId: parentFolder?.id }),
    onSuccess: () => {
      queryClient.resetQueries({
        queryKey: [LIST_FOLDER_CONTENTS_QUERY_KEY],
        exact: false,
      });
      queryClient.resetQueries({
        queryKey: [GET_FOLDER_HIERARCHY_QUERY_KEY],
        exact: false,
      });
      queryClient.resetQueries({
        queryKey: [HAS_SUBFOLDER_DESCRIPTIONS_QUERY_KEY],
        exact: false,
      });
      queryClient.resetQueries({
        queryKey: [FOLDER_COLUMN_VISIBILITY_QUERY_KEY],
        exact: false,
      });
    },
  });

  return {
    createFolder: mutate,
    isCreating: isPending,
    createError: getApiError(error),
  };
};
